/**
 * Plan d'action qualité d'une formation. Le plan est porté par la formation :
 * on récupère le même contenu qu'on l'ouvre depuis les réponses Pré-Formation,
 * Post-Formation ou Satisfaction.
 */
class ActionPlanApi {
    /** Formation, sessions (pour la liste déroulante) et lignes, en un appel. */
    async getFormationPlan(formationId, accessToken, signal = undefined) {
        const URL = `${process.env.REACT_APP_API_URL}/api/formations/${formationId}/action-plan`;
        const resp = await fetch(URL, {
            method: 'GET',
            signal,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    /**
     * Suivi transversal : les lignes non clôturées, toutes formations
     * confondues, et le compte clôturés / total.
     */
    async getOpenPlans(accessToken, signal = undefined) {
        const URL = `${process.env.REACT_APP_API_URL}/api/action-plans/open`;
        const resp = await fetch(URL, {
            method: 'GET',
            signal,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async createRow(formationId, values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/formations/${formationId}/action-plan`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async updateRow(id, values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/action-plan/${id}`;
        const resp = await fetch(URL, {
            method: 'PUT',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    /**
     * Écarte la proposition issue des réponses d'une session. L'écart est
     * enregistré en base : la proposition ne revient pas au rafraîchissement,
     * et elle disparaît aussi pour les autres utilisateurs.
     */
    async dismissSuggestion(formationId, sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/formations/${formationId}/action-plan/suggestions/${sessionId}/dismiss`;
        const resp = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    /** Remet à l'affichage toutes les propositions écartées d'une formation. */
    async restoreSuggestions(formationId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/formations/${formationId}/action-plan/suggestions/dismissed`;
        const resp = await fetch(URL, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async deleteRow(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/action-plan/${id}`;
        const resp = await fetch(URL, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
}

export const actionPlanApi = new ActionPlanApi();
